export const formatLongString = (str: string, maxLength: number = 32): string => {
  if (str.length <= maxLength) return str;
  
  const firstPart = str.substring(0, 12);
  const lastPart = str.substring(str.length - 12);
  
  return `${firstPart}…${lastPart}`;
}; 